import React from "react";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Common from "../../../layouts/Common";
import ResponsiveGallery from "react-responsive-gallery";
import love1 from "../../../assets/images/love1.jpg";
import love2 from "../../../assets/images/love2.jpg";
import love3 from "../../../assets/images/love3.jpg";
import love4 from "../../../assets/images/love4.jpg";
import love5 from "../../../assets/images/love5.jpg";
import love6 from "../../../assets/images/love6.jpg";
import love7 from "../../../assets/images/love7.jpg";





const TouchOfLove = () => {
  return (
    <Common>
      <section className="sub-page-banner newsr-bg">
        <Container>
          <Row>
            <Col md={12} className="text-center sup-page-inner">
              <h2>Media section</h2>
              <Breadcrumb className="text-center custom-breadcrumb">
                <Breadcrumb.Item>Home</Breadcrumb.Item>
                <Breadcrumb.Item>Media section</Breadcrumb.Item>
              </Breadcrumb>
            </Col>
          </Row>
        </Container>
      </section>
      <Container>
        <Row className="text-start mt-3">
          <Col md={12}>
            <section className="work-process mt-5">
              <h4 data-aos="flip-up">
              মোবাইল অ্যাপসে ভালোবাসা আর বসন্তের ছোঁয়া

              </h4>
              <label className="text-gray mb-2 w-100">
              Dated :  17 February, 2014
              </label>
            </section>
          </Col>
        </Row>
        <Col md={12} className="mb-5 border-topn pt-3 media-galery">
          <ResponsiveGallery
            useLightBox
            images={[
              {
                src: `${love1}`,
                alt: "med",
                orderS: 1,
                orderM: 1,
                orderL: 1,
                title:
                "মোবাইল অ্যাপসে ভালোবাসা আর বসন্তের ছোঁয়া",
              },
         
              
              {
                src: `${love2}`,
                alt: "med",
                orderS: 1,
                orderM: 1,
                orderL: 3,
                title:
                "মোবাইল অ্যাপসে ভালোবাসা আর বসন্তের ছোঁয়া",
              },
              {
                src: `${love3}`,
                alt: "gallery",
                orderS: 1,
                orderM: 1,
                orderL: 4,
                title:
                "মোবাইল অ্যাপসে ভালোবাসা আর বসন্তের ছোঁয়া",
              },

              {
                src: `${love4}`,
                alt: "gallery",
                orderS: 1,
                orderM: 1,
                orderL: 5,
                title:
                "মোবাইল অ্যাপসে ভালোবাসা আর বসন্তের ছোঁয়া",
              },
              {
                src: `${love5}`,
                alt: "gallery",
                orderS: 1,
                orderM: 1,
                orderL: 6,
                // imgClassName: 'img6-style',
                title:
                "মোবাইল অ্যাপসে ভালোবাসা আর বসন্তের ছোঁয়া",
              },

              {
                src: `${love6}`,
                alt: "gallery",
                orderS: 6,
                orderM: 6,
                orderL: 6,
                // imgClassName: 'img6-style',
                title:
                  "মোবাইল অ্যাপসে ভালোবাসা আর বসন্তের ছোঁয়া",
              },

              {
                src: `${love7}`,
                alt: "gallery",
                orderS: 6,
                orderM: 6,
                orderL: 6,
                // imgClassName: 'img6-style',
                title:
                  "মোবাইল অ্যাপসে ভালোবাসা আর বসন্তের ছোঁয়া",
              },
             
             
              
            ]}
          />
        </Col>
      </Container>
    </Common>
  );
};

export default TouchOfLove;
